import React, { useState, useEffect, useRef } from 'react'
import { useAuth } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom'

export default function Login({ close, anchorRef }) {
  const { login } = useAuth()
  const nav = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [position, setPosition] = useState({ top: 0, right: 0 })
  const cardRef = useRef(null)
  const [showCard, setShowCard] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  // Detecteaza dimensiunea ecranului
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Efect pentru pozitionarea cardului
  useEffect(() => {
    const updatePosition = () => {
      if (anchorRef?.current) {
        const rect = anchorRef.current.getBoundingClientRect()
        const viewportWidth = window.innerWidth
         const cardWidth = Math.min(isMobile ? 260 : 280, viewportWidth - 2*10) // Latimi diferite pentru mobile/desktop

        // Pe mobile: centrat cu distanta de margini
        if (isMobile) {
          const padding = 10; // distanta minimă față de margine
          const leftPosition = Math.max(padding, (viewportWidth - cardWidth) / 2);
          setPosition({
            top: rect.bottom + window.scrollY + 20,
            left: leftPosition + window.scrollX,
            right: 'auto'
          })
        }
        // Pe desktop: aliniat la dreapta iconitei
        else {
          const spaceRight = viewportWidth - rect.right

          // Daca nu incape la dreapta, muta-l la stanga
          if (spaceRight < cardWidth && rect.left > cardWidth) {
            setPosition({
              top: rect.bottom + window.scrollY + 20,
              right: viewportWidth - rect.left + window.scrollX,
              left: 'auto'
            })
          } else {
            setPosition({
              top: rect.bottom + window.scrollY + 20,
              left: rect.left + window.scrollX,
              right: 'auto'
            })
          }
        }
      }
    }

    updatePosition()
    setShowCard(true)

    window.addEventListener('resize', updatePosition)
    window.addEventListener('scroll', updatePosition)

    return () => {
      window.removeEventListener('resize', updatePosition)
      window.removeEventListener('scroll', updatePosition)
    }
  }, [anchorRef, isMobile])

  // Efect pentru detectarea clicurilor in afara cardului
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        cardRef.current &&
        !cardRef.current.contains(event.target) &&
        anchorRef?.current &&
        !anchorRef.current.contains(event.target)
      ) {
        close()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [anchorRef, close])

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await login(email, password); // login returneaza { token, user }
      close();

      // Redirectionare in functie de rol
      if (res.user.role === 'admin') nav('/admin');
      else if (res.user.role === 'host') nav('/host');
      else if (res.user.role === 'guest') nav('/guest');
      else nav('/'); // fallback

    } catch (err) {
      alert('Login failed');
    }
    setLoading(false);
  }


  if (!anchorRef?.current) return null

  return (
    <div
      ref={cardRef}
      className={`login-card ${showCard ? 'show' : ''}`}
      style={{
        position: 'absolute',
        top: position.top,
        left: position.left,
        right: position.right,
        width: isMobile ? `min(260px, calc(100vw - 40px))` : '280px', // Latime fixa, nu procentuala
        zIndex: 1000,
        transition: 'opacity 0.3s ease, transform 0.3s ease',
        opacity: showCard ? 1 : 0,
        transform: showCard ? 'translateY(0)' : 'translateY(-10px)'
      }}
    >
      <form onSubmit={handleSubmit} className="login-card-form">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          className="login-input"
        />
        <input
          type="password"
          placeholder="Parola"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          className="login-input"
        />
        <div className="login-card-buttons">
          <button
            type="button"
            className="btn-register-glass"
            onClick={() => {
              close()
              nav('/register')
            }}
          >
            Inregistrare
          </button>
          <button
            type="submit"
            className="btn-login-glass"
            disabled={loading}
          >
            {loading ? 'Se conecteaza...' : 'Conectare'}
          </button>
        </div>
      </form>
    </div>
  )
}